export const translatedInsuranceType = [
    {
        name: "COMPREHENSIVE",
        description: "Todos os Riscos",
        insuranceClass: "MOTOR"
    },
    {
        name: "THIRD_PARTY",
        description: "Terceiros",
        insuranceClass: "MOTOR"
    },
    {
        name: "THIRD_PARTY_PLUS_PERSONAL_LIABILITY",
        description: "Terceiros e Ocupantes",
        insuranceClass: "MOTOR"
    }
]